import React from 'react';
import { Container, Grid, Stack, Title, Text, TextInput, Textarea, Button, Group, Card } from '@mantine/core';
import { IconMail, IconPhone, IconMapPin, IconSend } from '@tabler/icons-react';
import { useForm } from '@mantine/form';

const Contact = () => {
  const form = useForm({
    initialValues: {
      name: '',
      email: '',
      subject: '',
      message: '',
    },
    validate: {
      name: (value) => (value.length < 2 ? 'Name must be at least 2 characters' : null),
      email: (value) => (/^\S+@\S+$/.test(value) ? null : 'Invalid email'),
      subject: (value) => (value.length < 2 ? 'Subject must be at least 2 characters' : null),
      message: (value) => (value.length < 10 ? 'Message must be at least 10 characters' : null),
    },
  });

  const handleSubmit = (values) => {
    console.log('Form submitted:', values);
    // Handle form submission here
  };

  const contactInfo = [
    {
      icon: <IconMail size={20} />,
      label: 'Email',
      value: 'contact@wildernessfinder.com'
    },
    {
      icon: <IconPhone size={20} />,
      label: 'Phone',
      value: '(555) 123-4567'
    },
    {
      icon: <IconMapPin size={20} />,
      label: 'Address',
      value: '123 Wilderness Way, Adventure City, AC 12345'
    }
  ];

  return (
    <Container size="xl">
      <Stack gap="xl">
        <Stack gap="sm" ta="center">
          <Title order={1} c="green">Contact Us</Title>
          <Text size="lg" c="dimmed">
            Have questions or feedback? We'd love to hear from you!
          </Text>
        </Stack>
        
        <Grid>
          <Grid.Col span={{ base: 12, md: 8 }}>
            <Card shadow="sm" padding="lg" radius="md" withBorder>
              <form onSubmit={form.onSubmit(handleSubmit)}>
                <Stack gap="md">
                  <TextInput
                    label="Name"
                    placeholder="Your name"
                    required
                    {...form.getInputProps('name')}
                  />
                  
                  <TextInput
                    label="Email"
                    placeholder="your.email@example.com"
                    required
                    type="email"
                    {...form.getInputProps('email')}
                  />
                  
                  <TextInput
                    label="Subject"
                    placeholder="What's this about?"
                    required
                    {...form.getInputProps('subject')}
                  />
                  
                  <Textarea
                    label="Message"
                    placeholder="Your message here..."
                    required
                    rows={5}
                    {...form.getInputProps('message')}
                  />
                  
                  <Button type="submit" color="green" rightSection={<IconSend size={16} />}>
                    Send Message
                  </Button>
                </Stack>
              </form>
            </Card>
          </Grid.Col>
          
          <Grid.Col span={{ base: 12, md: 4 }}>
            <Card shadow="sm" padding="lg" radius="md" withBorder h="100%">
              <Stack gap="md">
                <Title order={3} c="green">Get in Touch</Title>
                {contactInfo.map((info, index) => (
                  <Group key={index} gap="sm">
                    {info.icon}
                    <div>
                      <Text size="sm" fw={500}>{info.label}</Text>
                      <Text size="sm" c="dimmed">{info.value}</Text>
                    </div>
                  </Group>
                ))}
              </Stack>
            </Card>
          </Grid.Col>
        </Grid>
      </Stack>
    </Container>
  );
};

export default Contact;
